import overAll1 from '/public/siteImages/iOSTheme/themeType/theme1/overAll1.png';
import overAll2 from '/public/siteImages/iOSTheme/themeType/theme1/overAll2.png';
import overAll3 from '/public/siteImages/iOSTheme/themeType/theme1/overAll3.png';
import overAll4 from '/public/siteImages/iOSTheme/themeType/theme1/overAll4.png';
import overAll5 from '/public/siteImages/iOSTheme/themeType/theme2/overAll5.png';
import overAll6 from '/public/siteImages/iOSTheme/themeType/theme2/overAll6.png';
import overAll7 from '/public/siteImages/iOSTheme/themeType/theme2/overAll7.png';
import overAll8 from '/public/siteImages/iOSTheme/themeType/theme2/overAll8.png';
import overAll9 from '/public/siteImages/iOSTheme/themeType/theme3/overAll9.png';
import overAll10 from '/public/siteImages/iOSTheme/themeType/theme3/overAll10.png';
import overAll11 from '/public/siteImages/iOSTheme/themeType/theme3/overAll11.png';
import overAll12 from '/public/siteImages/iOSTheme/themeType/theme3/overAll12.png';
import overAll13 from '/public/siteImages/iOSTheme/themeType/theme4/overAll13.png';
import overAll14 from '/public/siteImages/iOSTheme/themeType/theme4/overAll14.png';
import overAll15 from '/public/siteImages/iOSTheme/themeType/theme4/overAll15.png';
import overAll16 from '/public/siteImages/iOSTheme/themeType/theme4/overAll16.png';

export {
    overAll1,
    overAll2,
    overAll3,
    overAll4,
    overAll5,
    overAll6,
    overAll7,
    overAll8,
    overAll9,
    overAll10,
    overAll11,
    overAll12,
    overAll13,
    overAll14,
    overAll15,
    overAll16
}